import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a3e7386")

_pushScopeId("data-v-4a3e7386")
const _hoisted_1 = { class: "CompletedDate" }
const _hoisted_2 = { class: "CompletedDate__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "header__title" }, "Дата и время забора", -1)
const _hoisted_4 = { class: "CompletedDate__body" }
const _hoisted_5 = { class: "body__right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_icon_close, {
            key: 0,
            class: "header__close",
            onClick: _ctx.emitReset
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("span", null, "Дата: " + _toDisplayString(_ctx.takeDate), 1),
      _createVNode("span", _hoisted_5, "Время: " + _toDisplayString(_ctx.takeTime), 1)
    ])
  ]))
})